import React, { useState } from "react";
import { Link } from "gatsby";
import classnames from "classnames";

const Header = () => {
  const [navOpen, setNavOpen] = useState(false);
  const navClasses = classnames("header__container nav", {
    "nav--open": navOpen,
  });

  return (
    <header className="header" role="banner">
      <nav className={navClasses} role="navigation">
        <ul>
          <li className="nav__logo">
            <Link to="/" title="Me!">
              <i className="icon__logo" />
              jamesbaum
            </Link>
          </li>
          <li>
            <Link to="/projects/" title="Projects">
              Projects <span className="nav__highlight" />
            </Link>
          </li>
          <li>
            <Link to="/games/" title="Games">
              Games <span className="nav__highlight" />
            </Link>
          </li>
          <li>
            <Link to="/blether/" title="Blog">
              Blether <span className="nav__highlight" />
            </Link>
          </li>
        </ul>
      </nav>
      <button
        type="button"
        className="nav__mobile-menu"
        onClick={() => setNavOpen(!navOpen)}
      >
        &#x2261;
      </button>
    </header>
  );
};

export default Header;
